var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRootContextualArticle)?_c('intersect',{attrs:{"threshold":[0],"root-margin":"0px 0px 0px 0px"},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_c('div',{staticClass:"contextual-article"},[_c('pulse-loader',{staticClass:"flex justify-center m-20",attrs:{"loading":_vm.isLoading,"color":"#0FF","size":"20px"}}),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }